module.exports = __webpack_public_path__ + "media/images/gallery/gallery1-0f0d8fd6ffefedcf1718ba7930dd2f00.jpg";